import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';
export const InlineIcon = _ref => {
  let {
    className,
    icon,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames(className, styles.icon),
    role: "presentation"
  }, props), icon);
};
//# sourceMappingURL=inline-icon.js.map